import Link from 'next/link';
import React from 'react';
import { Nav, Button } from 'react-bootstrap';

type HostButtonsProps = {
  urlSlug: string;
};

export default function HostButtons({ urlSlug }: HostButtonsProps) {
  return (
    <Nav style={{ marginTop: '-20px' }}>
      <Link
        href="/hosts/dashboard/[hostId]"
        as={`/hosts/dashboard/${urlSlug}`}
        passHref
        legacyBehavior
      >
        <Button as="a" className="me-2" variant="light" size="sm">
          Host Dashboard
        </Button>
      </Link>
      <Link
        href="/hosts/dashboard/[hostId]/edit/profile"
        as={`/hosts/dashboard/${urlSlug}/edit/profile`}
        passHref
        legacyBehavior
      >
        <Button as="a" variant="light" size="sm">
          Edit Page
        </Button>
      </Link>
    </Nav>
  );
}
